const LAST_STEP_TEXT = 'Letzter Schritt!'
const TWO_STEPS_LEFT_TEXT = 'Fast geschafft!'

// DAC 4 experiments
const PAGE_WITH_CUSTOM_TEXT_EXPERIMENTAL = {
  payoutAccount: LAST_STEP_TEXT,
  vehicle: TWO_STEPS_LEFT_TEXT,
  income: TWO_STEPS_LEFT_TEXT
}

export const getDAC4ProgressMessages = (
  percentage: number,
  currentPageInSession?: string | null,
  purpose?: string
): string => {
  const isCarLoanPurpose = purpose === 'PRE_OWNED_CAR' || purpose === 'NEW_CAR'

  if (
    currentPageInSession === 'payoutAccount' ||
    (currentPageInSession === 'income' && !isCarLoanPurpose) ||
    (currentPageInSession === 'vehicle' && isCarLoanPurpose)
  ) {
    return PAGE_WITH_CUSTOM_TEXT_EXPERIMENTAL[currentPageInSession]
  }

  if (percentage) {
    return `${percentage}%`
  }

  return ''
}
